/* eslint-disable no-script-url */
export const courses = [
					{
						name: "CS Prep",
						instructor: "Codesmith",
						hours: 30,
						platform: "Codesmith",
						image: "/assets/CSPrep.jpg",
						color: "red",
						link: "https://www.codesmith.io/bootcamp-prep",
					},
					{
						name: "The New Modern JavaScript Bootcamp",
						instructor: "Colt Steele & Stephen Grider",
						hours: 52,
						platform: "Udemy",
						image: "/assets/NewModernJavaScript.jpg",
						color: "blue",
						link:
							"https://www.udemy.com/course/javascript-beginners-complete-tutorial/",
					},
					{
						name: "The Modern JavaScript Bootcamp",
						instructor: "Andrew Mead",
						hours: 29.5,
						platform: "Udemy",
						image: "/assets/ModernJavaScript.jpg",
						color: "purple",
						link:
							"https://www.udemy.com/course/modern-javascript/",
					},
					{
						name:
							"JavaScript: From Fundamentals to Functional JS",
						instructor: "Bianca Gandolfo",
						hours: 8,
						platform: "Frontend Masters",
						image:
							"/assets/JavaScriptFundamentalToFunctional.jpg",
						color: "blue",
						link:
							"https://frontendmasters.com/courses/js-fundamentals-functional-v2/",
					},
					{
						name: "Getting Started with JavaScript",
						instructor: "Kyle Simpson",
						hours: 2.5,
						platform: "Frontend Masters",
						image: "/assets/GettingStartedWJS.jpg",
						color: "yellow",
						link:
							"https://frontendmasters.com/courses/getting-started-javascript-v2/",
					},
					{
						name: "Advanced JavaScript Concepts",
						instructor: "Andrei Neagoie",
						hours: 24.5,
						platform: "Udemy",
						image: "/assets/advancedJavaScriptConcepts.jpg",
						color: "blue",
						link:
							"https://www.udemy.com/course/advanced-javascript-concepts/",
					},
					{
						name: "JavaScript: The Hard Parts",
						instructor: "Will Sentance",
						hours: 7,
						platform: "Frontend Masters",
						image: "/assets/JSHardParts.jpg",
						color: "grey",
						link:
							"https://frontendmasters.com/courses/javascript-hard-parts/",
					},
					{
						name: "Hard Parts: Functional JS Foundations",
						instructor: "Will Sentence",
						hours: 5,
						platform: "Frontend Masters",
						image: "/assets/HPFunctionalJS.jpg",
						color: "blue",
						link:
							"https://frontendmasters.com/courses/functional-js-fundamentals/",
					},
					{
						name:
							"JavaScript: The Hard Parts of Object Oriented JavaScript",
						instructor: "Will Sentance",
						hours: 4.5,
						platform: "Frontend Masters",
						image: "/assets/HardPartsOOP.png",
						color: "orange",
						link:
							"https://frontendmasters.com/courses/object-oriented-js/",
					},
					{
						name: "JavaScript: The New Hard Parts",
						instructor: "Will Sentance",
						hours: 5,
						platform: "Frontend Masters",
						image: "/assets/NewHardParts.png",
						color: "red",
						link:
							"https://frontendmasters.com/courses/javascript-new-hard-parts/",
					},
					{
						name: "JavaScript: Getting Started",
						instructor: "Mark Zamoyta",
						hours: 3,
						platform: "Pluralsight",
						image: "/assets/JSGettingStarted.jpg",
						color: "yellow",
						link:
							"https://www.pluralsight.com/courses/javascript-getting-started",
					},
					{
						name: "JavaScript Fundamentals",
						instructor: "Mark Zamoyta",
						hours: 3,
						platform: "Pluralsight",
						image: "/assets/JSFundamentals.jpg",
						color: "yellow",
						link:
							"https://www.pluralsight.com/courses/javascript-fundamentals",
					},
					{
						name: "JavaScript Objects and Prototypes",
						instructor: "Jim Cooper",
						hours: 1,
						platform: "Pluralsight",
						image: "/assets/JSObjectsPrototypes.jpg",
						color: "yellow",
						link:
							"https://www.pluralsight.com/courses/javascript-objects-prototypes",
					},
					{
						name:
							"TypeScript: The Complete Developer's Guide",
						instructor: "Stephen Grider",
						hours: 24.5,
						platform: "Udemy",
						image: "/assets/TypeScriptGrider.jpg",
						color: "blue",
						link:
							"https://www.udemy.com/course/typescript-the-complete-developers-guide/",
					},
					{
						name: "Understanding TypeScript 2020 Edition",
						instructor: "Maximilian Schwarzmüller",
						hours: 15,
						platform: "Udemy",
						image: "/assets/TypeScriptSchwarzmuller.jpg",
						color: "blue",
						link:
							"https://www.udemy.com/course/understanding-typescript/",
					},
					{
						name:
							"Complete Python Developer in 2020: Zero to Mastery",
						instructor: "Andrei Neagoie",
						hours: 30,
						platform: "Udemy",
						image: "/assets/CompletePythonDeveloper.jpg",
						color: "yellow",
						link:
							"https://www.udemy.com/course/complete-python-developer-zero-to-mastery/",
					},
					{
						name:
							"Complete Machine Learning and Data Science: Zero to Mastery",
						instructor: "Andrei Neagoie",
						hours: 43,
						platform: "Udemy",
						image: "/assets/CompleteMLDS.jpg",
						color: "purple",
						link:
							"https://www.udemy.com/course/complete-machine-learning-and-data-science-zero-to-mastery/",
					},
					{
						name:
							"Python for Machine Learning and Data Science Bootcamp",
						instructor: "Jose Portilla",
						hours: 25,
						platform: "Udemy",
						image: "/assets/PythonMLDS.jpeg",
						color: "yellow",
						link:
							"https://www.udemy.com/course/python-for-data-science-and-machine-learning-bootcamp/",
					},

					{
						name: "jQuery Crash Course",
						instructor: "Brad Traversy",
						hours: 1.6,
						platform: "Youtube",
						image: "/assets/jquery.png",
						color: "orange",
						link:
							"https://www.youtube.com/playlist?list=PLillGF-RfqbYJVXBgZ_nA7FTAAEpp_IAc",
					},
					{
						name: "Modern React with Redux",
						instructor: "Stephen Grider",
						hours: 30,
						platform: "Udemy",
						image: "/assets/modernReactWithRedux.jpeg",
						color: "blue",
						link:
							"https://www.udemy.com/course/react-redux/",
					},
					{
						name: "The Modern React Bootcamp",
						instructor: "Colt Steele",
						hours: 39,
						platform: "Udemy",
						image: "/assets/TMRB.jpg",
						color: "pink",
						link:
							"https://www.udemy.com/course/modern-react-bootcamp/",
					},
					{
						name: "Complete React Developer in 2019",
						instructor: "Andrei Neagoie",
						hours: 39,
						platform: "Udemy",
						image: "/assets/CRD2019.jpg",
						color: "purple",
						link:
							"https://www.udemy.com/course/complete-react-developer-zero-to-mastery/",
					},
					{
						name:
							"Build an app with React, Redux, and Firestore from scratch",
						instructor: "Neil Cummings",
						hours: 29,
						platform: "Udemy",
						image: "/assets/NCCourse.jpg",
						color: "green",
						link:
							"https://www.udemy.com/course/build-an-app-with-react-redux-and-firestore-from-scratch/",
					},
					{
						name: "Complete Intro to React",
						instructor: "Brian Holt",
						hours: 5.5,
						platform: "Frontend Masters",
						image: "/assets/CompleteIntroToReact.png",
						color: "blue",
						link:
							"https://frontendmasters.com/courses/complete-react-v5/",
					},
					{
						name: "Intermediate React",
						instructor: "Brian Holt",
						hours: 4,
						platform: "Frontend Masters",
						image: "/assets/IntermediateReact.png",
						color: "green",
						link:
							"https://frontendmasters.com/courses/intermediate-react-v2/",
					},
					{
						name: "State Management with Redux & MobX",
						instructor: "Steve Kinney",
						hours: 5,
						platform: "Frontend Masters",
						image: "/assets/ReduxMobX.jpg",
						color: "orange",
						link:
							"https://frontendmasters.com/courses/redux-mobx/",
					},
					{
						name:
							"Building Applications with React and Redux",
						instructor: "Cory House",
						hours: 6.5,
						platform: "Pluralsight",
						image: "/assets/ReactReduxCourse.png",
						color: "violet",
						link:
							"https://app.pluralsight.com/library/courses/react-redux-react-router-es6/table-of-contents",
					},
					{
						name: "React Context & Hooks Tutorial",
						instructor: "Shaun Pelling",
						hours: 2.5,
						platform: "Youtube",
						image: "/assets/ReactHooksContext.png",
						color: "red",
						link:
							"https://www.youtube.com/watch?v=6RhOzQciVwI",
					},
					{
						name: "React Hooks Series",
						instructor: "Ahmed Hadjou",
						hours: 1,
						platform: "Youtube",
						image: "/assets/ReactHooksSeries.jpg",
						color: "yellow",
						link:
							"https://www.youtube.com/playlist?list=PLMhAeHCz8S3-q2TPHYhlppM3UcevsqFRf",
					},
					{
						name:
							"The Complete React Native + Hooks Course",
						instructor: "Stephen Grider",
						hours: 22,
						platform: "Udemy",
						image: "/assets/ReactNativeHooks.jpg",
						color: "blue",
						link:
							"https://www.udemy.com/course/the-complete-react-native-and-redux-course/",
					},
					{
						name: "React Native - The Practical Guide",
						instructor: "Maximilian Schwarzmüeller",
						hours: 30.5,
						platform: "Udemy",
						image: "/assets/RNPracticalGuide.jpg",
						color: "blue",
						link:
							"https://www.udemy.com/course/react-native-the-practical-guide/",
					},
					{
						name: "The Modern GraphQL Bootcamp",
						instructor: "Andrew Mead",
						hours: 23.5,
						platform: "Udemy",
						image: "/assets/modern-graphql-bootcamp.jpg",
						color: "blue",
						link:
							"https://www.udemy.com/course/graphql-bootcamp/",
					},
					{
						name: "Introduction to GraphQL",
						instructor: "Scott Moss",
						hours: 3.5,
						platform: "Frontend Masters",
						image: "/assets/GraphQL.jpg",
						color: "pink",
						link:
							"https://frontendmasters.com/courses/graphql/",
					},
					{
						name: "GraphQL Full Course - Novice to Expert",
						instructor: "Shaun Pelling",
						hours: 4,
						platform: "Youtube",
						image: "/assets/GraphQL2.jpeg",
						color: "teal",
						link:
							"https://www.youtube.com/watch?v=ed8SzALpx1Q",
					},
					{
						name: "GraphQL Server Series (MERNG)",
						instructor: "Ahmed Hadjou",
						hours: 2,
						platform: "Youtube",
						image: "/assets/GraphQLServerSeries.jpg",
						color: "green",
						link:
							"https://www.youtube.com/playlist?list=PLMhAeHCz8S3_CTiWMQhL6YxX7vZ7z84Zo",
					},
					{
						name: "React GraphQL App Series (MERNG)",
						instructor: "Ahmed Hadjou",
						hours: 3.75,
						platform: "Youtube",
						image: "/assets/ReactGraphQL.jpeg",
						color: "green",
						link:
							"https://www.youtube.com/playlist?list=PLMhAeHCz8S3_pgb-j51QnCEhXNj5oyl8n",
					},
					{
						name: "Introduction to Gatsby",
						instructor: "Jason Lengstorf",
						hours: 3.75,
						platform: "Frontend Masters",
						image: "/assets/JLengstorf.jpg",
						color: "grey",
						link:
							"https://frontendmasters.com/courses/gatsby/",
					},
					{
						name: "Gatsby JS - The Great Gatsby Bootcamp",
						instructor: "Andrew Mead",
						hours: 4.5,
						platform: "Youtube",
						image: "/assets/GatsbyBootcamp.jpg",
						color: "violet",
						link:
							"https://www.youtube.com/watch?v=8t0vNu2fCCM",
					},
					{
						name: "Create a GatsbyJS Blog",
						instructor: "Ahmed Hadjou",
						hours: 4.5,
						platform: "Youtube",
						image: "/assets/GatsbyBlogYoutube.jpg",
						color: "blue",
						link:
							"https://www.youtube.com/playlist?list=PLMhAeHCz8S3_x-jXerCYnl7jftCSxQkPV",
					},
					{
						name: "Microservices with Node JS and React",
						instructor: "Stephen Grider",
						hours: 49,
						platform: "Udemy",
						image: "/assets/Microservices.jpg",
						color: "blue",
						link:
							"https://www.udemy.com/course/microservices-with-node-js-and-react/",
					},
					{
						name: "Full Stack for Front End Engineers",
						instructor: "Jem Young",
						hours: 4,
						platform: "Frontend Masters",
						image: "/assets/FullStack1.jpg",
						color: "red",
						link:
							"https://frontendmasters.com/courses/full-stack/",
					},
					{
						name: "Full Stack for Front-Ends Part 2",
						instructor: "Jem Young",
						hours: 5,
						platform: "Frontend Masters",
						image: "/assets/FullStack2.png",
						color: "purple",
						link:
							"https://frontendmasters.com/courses/full-stack-v2/",
					},
					{
						name: "Introduction to Node.js",
						instructor: "Scott Moss",
						hours: 5,
						platform: "Frontend Masters",
						image: "/assets/IntroToNode.jpg",
						color: "green",
						link:
							"https://frontendmasters.com/courses/node-js/",
					},
					{
						name: "VueJS 2 – The Complete Guide",
						instructor: "Maximilian Schwarzmüller",
						hours: 22,
						platform: "Udemy",
						image: "/assets/VueJS2Course.jpg",
						color: "green",
						link:
							"https://www.udemy.com/course/vuejs-2-the-complete-guide/",
					},
					{
						name: "Mastering Chrome Developer Tools",
						instructor: "Jon Kuperman",
						hours: 3.5,
						platform: "Frontend Masters",
						image: "/assets/ChromeDevTools.jpg",
						color: "blue",
						link:
							"https://frontendmasters.com/courses/chrome-dev-tools-v2/",
					},
					{
						name: "CSS - The Complete Guide",
						instructor: "Maximilian Schwarzmueller",
						hours: 23,
						platform: "Udemy",
						image: "/assets/CSSComplete.jpg",
						color: "blue",
						link:
							"https://www.udemy.com/course/css-the-complete-guide-incl-flexbox-grid-sass/",
					},
					{
						name: "Advanced CSS and Sass",
						instructor: "Jonas Schmedtmann",
						hours: 28,
						platform: "Udemy",
						image: "/assets/advancedCSSSass.jpg",
						color: "pink",
						link:
							"https://www.udemy.com/course/advanced-css-and-sass/",
					},
					{
						name:
							"CSS Grids and Flexbox for Responsive Web Design",
						instructor: "Jen Kramer",
						hours: 5.5,
						platform: "Frontend Masters",
						image: "/assets/CSSGridFlexbox.png",
						color: "grey",
						link:
							"https://frontendmasters.com/courses/css-grids-flexbox/",
					},
					{
						name: "Website Accessibility",
						instructor: "Jon Kuperman",
						hours: 4,
						platform: "Frontend Masters",
						image: "/assets/WebsiteAccessibility.jpg",
						color: "green",
						link:
							"https://frontendmasters.com/courses/web-accessibility/",
					},
					{
						name: "Visual Studio Code Can Do That?",
						instructor: "Burke Holland",
						hours: 3.5,
						platform: "Frontend Masters",
						image: "/assets/VSCode.png",
						color: "red",
						link:
							"https://frontendmasters.com/courses/customize-vs-code/",
					},
					{
						name:
							"HTML, CSS, and JavaScript: The Big Picture",
						instructor: "Barry Luijbregts",
						hours: 1.5,
						platform: "Pluralsight",
						image: "/assets/HTMLCSSJS.jpeg",
						color: "red",
						link:
							"https://www.pluralsight.com/courses/html-css-javascript-big-picture",
					},
					{
						name: "The Web Developer Bootcamp",
						instructor: "Colt Steele",
						hours: 47,
						platform: "Udemy",
						image: "/assets/WDB.jpg",
						color: "red",
						link:
							"https://www.udemy.com/course/the-web-developer-bootcamp/",
					},
					{
						name: "Complete Intro to Web Development",
						instructor: "Brian Holt",
						hours: 11,
						platform: "Frontend Masters",
						image: "/assets/CompleteIntro.jpg",
						color: "blue",
						link:
							"https://frontendmasters.com/courses/web-development-v2/",
					},
					{
						name: "Modern Search Engine Optimization",
						instructor: "Mike North",
						hours: 4,
						platform: "Frontend Masters",
						image: "/assets/ModernSEO.jpg",
						color: "teal",
						link:
							"https://frontendmasters.com/courses/modern-seo/",
					},
				];
